export default __webpack_public_path__ + "information-button.png";